import "./components/MachineSettings/Endpoints/register";